<template lang='pug'>
  bf-flex#v-hash.centered
    h1 d3fc3945cee832d1a5a87b70b6c34611d6b7bc34
</template>

<script>
  export default {
    name: 'v-hash.view',
  }
</script>

<style scoped lang='stylus'>
  #v-hash
    min-height 100vh
    min-width 100vw
    @media( max-width 640px )
      h1
        font-size 1.5em
    @media( max-width 480px )
      h1
        font-size 1.25em
</style>
